import Incertitude from "@/models/Incertitude";
import { incertitudeApi } from "@/api/projectClient";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";
import { useMissionStore } from "@/store/modules/mission";

const IncertitudeRepo = useRepo(Incertitude);

export const useIncertitudeStore = defineStore("incertitude", {
  state: () => ({}),

  actions: {
    async fetchIncertitudes() {
      IncertitudeRepo.flush();
      const missionStore = useMissionStore();
      const { results } = await incertitudeApi.list({
        project: missionStore.currentMission.uuid,
        pageSize: 150,
      });
      if (results.length) {
        IncertitudeRepo.save(results);
      }
    },

    async createOrUpdateIncertitude(incertitude) {
      if (!incertitude.uuid) {
        const created = await incertitudeApi.create({
          incertitudeRequest: incertitude,
        });
        return IncertitudeRepo.insert(created);
      }
      const updated = await incertitudeApi.update({
        uuid: incertitude.uuid,
        incertitudeRequest: incertitude,
      });
      return IncertitudeRepo.save(updated);
    },

    async deleteIncertitude(incertitude) {
      await incertitudeApi.destroy({ uuid: incertitude.uuid });
      IncertitudeRepo.destroy(incertitude.uuid);
    },
  },
  getters: {},
});
